import script from "./ChatBotComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatBotComponent.vue?vue&type=script&setup=true&lang=js"

import "./ChatBotComponent.vue?vue&type=style&index=0&id=90d0c18a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90d0c18a"]])

export default __exports__